(() => {
  const bind = (scroller) => {
    if (!scroller || scroller.dataset.fatNavBound) return;
    scroller.dataset.fatNavBound = '1';

    const nav = scroller.closest('.product-fat').querySelector('.product-fat__nav');
    const prev = nav && nav.querySelector('[is="prev-button"]');
    const next = nav && nav.querySelector('[is="next-button"]');
    if (!prev || !next) return;

    next.addEventListener('control:next', (event) => {
      event.stopPropagation();
      scroller.dispatchEvent(new CustomEvent('control:next', { cancelable: true }));
    });

    // The theme's prev/next buttons bind their scroll-edge listeners only if their
    // aria-controls target already exists when they upgrade. Here the arrows are in the
    // header, before the <scroll-carousel>, so that wiring never happens and the buttons
    // stay stuck (prev disabled, next enabled). Drive the disabled state from the real
    // scroll position instead.
    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const x = Math.abs(scroller.scrollLeft);
      prev.disabled = x <= 4;
      next.disabled = max <= 4 || x >= max - 4;
    };

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
    setTimeout(update, 300);
  };

  const bindAll = () => document.querySelectorAll('.product-fat__scroller').forEach(bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
